import * as React from "react";

import history from "../../utils/history";
import styled from "react-emotion";
import Content from "../../components/Content";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import DashboardMenu from "../../components/Menu";
import ComingSoon from "./ComingSoon";
import FAQ from "./FAQ";
import Hedging from "./Hedging";
import Summarizer from "./Summarizer";
import Exposure from "./Exposure";
import SpeechRecognition from "./SpeechRecognition";
import TextSentiment from "./TextSentiment";
import CrossProvider from "./CrossProvider";
import TextSummarizer from "./TextSummarizer";
import NamedEntityRecognition from "./NamedEntityRecognition";
import Translation from "./Translation";
import QuestionAnswering from "./QuestionAnswering";
import ArticleSummarizer from "./ArticleSummarizer";
import ArticleKeywords from "./ArticleKeywords";
import VideoToText from "./VideoToText";
import TextExtraction from "./TextExtraction";
import TextGeneration from "./TextGeneration";
import TextToSpeech from "./TextToSpeech";
import TextEmotion from "./TextEmotion";
import FearAndGreedIndex from "./FearAndGreedIndex";
import RedditPosts from "./RedditPosts";
import SocialSentiment from "./SocialSentiment";
import VisionAI from "./VisionAI";
import ParaphrasingTool from "./ParaphrasingTool";
import TextSimilarity from "./TextSimilarity";
import FaceDetection from "./FaceDetection";
import ImageContent from "./ImageContent";
import GrammarChecker from "./GrammarChecker";
import Jokes from "./Jokes";
import FaceRecognition from "./FaceRecognition";
import FaceRestoration from "./FaceRestoration";
import Text2Art from "./Text2Art";
import Weather from "./Weather";
import DeepFakeDetection from "./DeepFakeDetection";
import Avatar from "./Avatar";
import ImageLabeling from "./ImageLabeling";
import Chatbot from "./Chatbot";
import MemeGenerator from "./MemeGenerator";
import TripPurpose from "./TripPurpose";
import TextCompletion from "./TextCompletion";

const Container = styled("div")`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 20px minmAIax(80vh, auto) minmax(19vh, auto);
  min-height: 100vh;

  @media (max-width: 1024px) {
    grid-template-rows: 20px auto;
  }
`;

const MenuAndContent = styled("div")`
  display: flex;
  margin-top: 40px;
  grid-column: 3/11;

  @media (max-width: 1680px) {
    grid-column: 1/13;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-column: 1/-1;
  }
`;

const screens = {
  "article-keywords": <ArticleKeywords/>,
  "article-summarizer": <ArticleSummarizer/>,
  "avatar": <Avatar/>,
  "chatbot": <Chatbot/>,
  "cross-provider": <CrossProvider/>,
  "event": <ComingSoon/>,
  "exposure": <Exposure/>,
  "face-detection": <FaceDetection/>,
  "face-similarity": <FaceRecognition/>,
  "face-restoration": <FaceRestoration/>,
  "fear-and-greed-index": <FearAndGreedIndex/>,
  "deepfake-detection": <DeepFakeDetection/>,
  "text2art": <Text2Art/>,
  "faq": <FAQ/>,
  "grammar-checker": <GrammarChecker/>,
  "hedging": <Hedging/>,
  "image-content": <ImageContent/>,
  "image-labeling": <ImageLabeling/>,
  "meme-generator": <MemeGenerator/>,
  "jokes": <Jokes/>,
  "ner-extraction": <NamedEntityRecognition/>,
  "paraphrasing-tool": <ParaphrasingTool/>,
  "question-answering": <QuestionAnswering/>,
  "reddit-posts": <RedditPosts/>,
  "social-sentiment": <SocialSentiment/>,
  "speech-recognition": <SpeechRecognition/>,
  "summarizer": <Summarizer/>,
  "text-completion": <TextCompletion/>,
  "text-emotion": <TextEmotion/>,
  "text-extraction": <TextExtraction/>,
  "text-generation": <TextGeneration/>,
  "text-sentiment": <TextSentiment/>,
  "text-similarity": <TextSimilarity/>,
  "text-summarizer": <TextSummarizer/>,
  "text-to-speech": <TextToSpeech/>,
  "translation": <Translation/>,
  "trip-purpose": <TripPurpose/>,
  "video-to-text": <VideoToText/>,
  "vision-ai": <VisionAI/>,
  "weather": <Weather/>,
};

interface IDashboardProps {
  location: { pathname: string };
  openContactForm: any;
}

interface IDashboardState {
  screen: string;
}

class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
  public state: {
    screen: string;
  };

  constructor(props: IDashboardProps) {
    super(props);
    const screen: string = props.location.pathname.split("/")[2];
    this.state = {
      screen
    };
    this.setScreen = this.setScreen.bind(this);
  }

  public setScreen = (screenName: string) => {
    this.setState({ screen: screenName });
  };

  public render() {
    return (
      <Container>
        <Header history={history} />
        <MenuAndContent>
          <DashboardMenu
            screen={this.state.screen}
            setScreen={this.setScreen}
          />
          <Content screen={this.state.screen} screensMapping={screens} />
        </MenuAndContent>
        <Footer openContactForm={this.props.openContactForm} />
      </Container>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/index.tsx